import { parse, format } from "date-fns";

/// number of milliseconds on a day.
const MILLISECONDS = 86_400_000 as const;
const DATE_FORMAT = "yyyy-MM-dd";

export class NaiveDate {
  year: number;
  month: number;
  day: number;

  constructor(year?: number, month?: number, day?: number) {
    if (year === undefined || month === undefined || day === undefined) {
      const date = new Date();
      this.year = date.getFullYear();
      this.month = date.getMonth();
      this.day = date.getDate();
    } else {
      this.year = year || 0;
      this.month = month || 0;
      this.day = day || 1;
    }
  }

  static fromDate(date: Date): NaiveDate {
    return new NaiveDate(date.getFullYear(), date.getMonth(), date.getDate());
  }

  toLocale(): Date {
    return new Date(this.year, this.month, this.day);
  }

  static parse(str: string): NaiveDate {
    return NaiveDate.fromDate(parse(str, DATE_FORMAT, new Date()));
  }

  format(): string {
    return format(new Date(this.year, this.month, this.day), DATE_FORMAT);
  }

  valueOf(): Date {
    return this.toLocale();
  }

  toString(): string {
    return this.format();
  }
}

export const diffInDays = (a: Date, b: Date): number =>
  Math.ceil((a.getTime() - b.getTime()) / MILLISECONDS);
